import { Component, OnInit } from '@angular/core';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { UserService } from 'src/app/Service/User/User.service';

@Component({
  selector: 'app-UserUrl',
  templateUrl: './UserUrl.component.html',
  styleUrls: ['./UserUrl.component.scss']
})
export class UserUrlComponent implements OnInit {

  Token:String=""
  Selected_User_Id:String="0"
  page=0

  Procssing:boolean=false



  constructor(
    private User_Service:UserService,
    private Nav_Service:NavService,
  ) { }


  DataList_User:Array<General_Interface>=[]
  DataList_User_Option:Array<User_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token,1164).subscribe(
      data=>{
        this.Read_User_Option()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  Read_User_Option(){
    this.Procssing=true
    this.User_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_User_Option=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  ReadData_User(StartSearchDate,EndSearchDate){
    this.Procssing=true
    this.User_Service.GetLogingUrl(this.Token,StartSearchDate,EndSearchDate,this.Selected_User_Id).subscribe(
      data=>{
        this.DataList_User=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

}
